
<div class="points__card-container">  
  <article 
    [style.view-transition-name]="'timeline-img-' + point().id"
    class="points__card"
    [style]="'--bg-img-url: url(' + getEncodedBgImgUrl(point().img) + ')'"
    (click)="goToDetailPage(point().id, point().type, 'timeline')"
  >
    <app-header 
      [indexCard]="indexCard()"
      [point]="point()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
    
    <app-main
      [title]="point().title"
      [id]="point().id"
      [indexCard]="indexCard()"
      [startDate]="getStartDate()"
      [durationMinutes]="point().duration"
      [isLocationCard]="isLocationCard()"
      [isDuration15Minutes]="isDuration15Minutes()"
    />
  </article>
</div>
